import Script from "next/script";
import { IconButton } from "@/components/Button";
import { UrlString } from "@/models/api";
import { WP_Image } from "@/models";

import s from "./PageShare.module.scss";

interface Props {
	url: UrlString;
	img?: WP_Image;
	title: string;
}

export function PinterestButton({ url, img, title }: Props) {
	// replace with props at later moment, or define some sensible default content here.
	/* if not provided it should grab a picture on it's own (not sure) */
	const pinMedia = img?.media_details.sizes["medium"].source_url || "";
	const pinDescription = title;

	const pinUrl = `https://www.pinterest.com/pin/create/button?url=${url}&media=${pinMedia}&description=${pinDescription}`;

	return (
		<div className={s.svgWrapper}>
			<Script
				id="pinterest"
				type="text/javascript"
				strategy="lazyOnload"
				dangerouslySetInnerHTML={{
					__html: `(function (d) {const f = d.getElementsByTagName('SCRIPT')[0],p = d.createElement('SCRIPT');p.type = 'text/javascript';p.async = true;p.src = '//assets.pinterest.com/js/pinit.js';f.parentNode.insertBefore(p, f);})(document);`,
				}}
			/>
			<IconButton
				as="a"
				rel="noreferrer"
				icon="pinterest"
				label="Deel via Pinterest"
				href={pinUrl}
				target="_blank"
				data-pin-url={pinUrl}
				data-pin-do="buttonBookmark"
				data-pin-custom="true"
			/>
		</div>
	);
}
